let adminAccess = [
  "arnav010singh@gmail.com",
  "arnavzek@gmail.com",
  "eden@djizef.com",
  "nour.reda96@hotmail.com",
];

export default adminAccess;
